import { render, staticRenderFns } from "./unsubscribe-confirmation.component.vue?vue&type=template&id=2cba11b0&scoped=true"
import script from "./unsubscribe-confirmation.component.vue?vue&type=script&lang=js"
export * from "./unsubscribe-confirmation.component.vue?vue&type=script&lang=js"
import style0 from "./unsubscribe-confirmation.component.vue?vue&type=style&index=0&id=2cba11b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cba11b0",
  null
  
)

export default component.exports